import { ProductService } from '../../providers'

const ProductModule = {
  namespaced: true,
  state: {
    products: []
  },
  mutations: {
    SET_PRODUCTS (state, data) {
      state.products = data
    }
  },
  actions: {
    async fetchProducts ({ commit }) {
      const result = await ProductService.fetchProducts()
      commit('SET_PRODUCTS', result)
      return result
    }
  }
}

export default ProductModule
